type Props = {
  collapsed?: boolean;
};

export default function AttendanceIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.2)" }}
        className={collapsed ? "" : "relative left-[5px]"}
      >
        <path
          d="M6 13.1949H12M6 10.1949H12M12.0002 2.69495H15.75C15.9489 2.69495 16.1397 2.77396 16.2803 2.91462C16.421 3.05527 16.5 3.24603 16.5 3.44495V19.1949C16.5 19.3939 16.421 19.5846 16.2803 19.7253C16.1397 19.8659 15.9489 19.9449 15.75 19.9449H2.25C2.05109 19.9449 1.86032 19.8659 1.71967 19.7253C1.57902 19.5846 1.5 19.3939 1.5 19.1949V3.44495C1.5 3.24603 1.57902 3.05527 1.71967 2.91462C1.86032 2.77396 2.05109 2.69495 2.25 2.69495H5.9998M5.25 5.69495V4.94495C5.25 3.95038 5.64509 2.99656 6.34835 2.2933C7.05161 1.59003 8.00544 1.19495 9 1.19495C9.99456 1.19495 10.9484 1.59003 11.6517 2.2933C12.3549 2.99656 12.75 3.95038 12.75 4.94495V5.69495H5.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
